export const SkillsData = [
  {
    type: "Front-End",
    list: [
      {
        name: "ReactJS",
        icon: <i class="devicon-react-original colored"></i>
        },
      {
        name: "HTML5",
        icon: <i class="devicon-html5-plain colored"></i>
        },
      {
        name: "JavaScript",
        icon: <i class="devicon-javascript-plain colored"></i>
      },
      {
        name: "TailwindCSS",
        icon: <i class="devicon-tailwindcss-plain colored"></i>
      },
    ],
  },
  {
    type: "Other Skills",
    list: [
      {
        name: "Firebase",
        icon: <i class="devicon-firebase-plain colored"></i>
      },
      {
        name: "Bootstrap",
        icon: <i class="devicon-bootstrap-plain colored"></i>
      },
      {
        name: "Figma",
        icon: <i class="devicon-figma-plain colored"></i>
      },
      {
        name: "Webflow design",
        icon: <i class="devicon-webflow-original colored"></i>
      }
      
    ],
  },
];